import {AfterContentInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable, Subscription}                 from 'rxjs';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridStatusColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridGroupColumnConfig
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  LanguageStore
}                                                                  from '../../stores/translation/language.store';
import {filter, map, skip}                                         from 'rxjs/operators';
import {MapViewMode}                                               from '../../ap-interface';
import {
  MapViewStore
}                                                                  from '../../stores/layout/mapview.store';
import {
  ApUtilService
}                                                                  from '../../ap-utils/service/ap-util.service';
import {
  FormStore,
  IEntryComponent
}                                                                  from '../../stores/layout/form.store';
import {
  FieldStore
}                                                                  from '../../stores/farm/field.store';
import {
  FertilizerStore
}                                                                  from '../../stores/base-data/fertilizer.store';
import {
  CropTypeStore
}                                                                  from '../../stores/base-data/crop.types.store';
import {
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardSection
}                                                                  from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApDynformsConfigFieldset
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigNumerictextbox
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  ApDynformsConfigDatepicker
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {
  ModalDialogStore
}                                                                  from '../../stores/dialog/modal.dialog.store';
import {
  IModalDialogData,
  ModalDialogButtonDisable
}                                                                  from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  CampaignYearStore
}                                                                  from '../../stores/login/campaignyear.store';
import {
  ApTranslationService
}                                                                  from '../../ap-utils/service/ap-translation.service';
import {
  NFertilizationStore
}                                                                  from '../../stores/n-fertilization/n-fertilization.store';
import {
  ApDynComponentComponent
}                                                                  from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynformsConfigComboBox
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-combobox';
import {
  DriverStore
}                                                                  from '../../stores/docu/driver.store';
import {
  MachineStore
}                                                                  from '../../stores/docu/machine.store';
import {
  InstrumentStore
}                                                                  from '../../stores/docu/instrument.store';
import {ObjectFactory}                                             from 'ts-tooling';
import {
  GetRoundNumericService
}                                                                  from '../../ap-utils/service/get-round-numeric.service';
import {
  INFertilizationBookingGridData,
  INFertilizationBookingSingleEditData
}                                                                  from './ap-n-fertilization-booking-configs/n-fertilization-booking-types';
import {ApTimeSpanUtil, GetRoundNumericPipe}                       from '../../ap-utils';
import {
  CombinedFertilizer
}                                                                  from '../../types/common-types';
import {
  FertilizerService
}                                                                  from '../../services/data/fertilizer.service';
import {
  CampaignYearService
}                                                                  from '../../services/data/campaign-year.service';
import {
  ApDateService
}                                                                  from '../../ap-core/services/ap-date-service';
import {
  FertilizationManagementService
}                                                                  from '../../services/data/fertilization-management.service';
import {
  nameOf
}                                                                  from '../../ap-core/utils/ap-name-of';
import {
  TimeAreaService
}                                                                  from '../../services/data/time-area.service';
import {
  TimeFormatPipe
}                                                                  from '../../ap-utils/pipes/ap-format-duration.pipe';
import {
  FormatType
}                                                                  from '../../ap-utils/types/ap-format-duration.types';
import {
  ApTooltipContentService
}                                                                  from '../../ap-utils/service/ap-tooltip-content.service';
import {
  ApDynformsConfigPlaceholder
}                                                                  from '../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {
  ApElementType
}                                                                  from '../../ap-interface/enums/ap-elements-type.enum';
import {NeutralFactor}                                             from '../../shared/constants';
import IGuid = System.IGuid;
import INFertilizationPlanBook = Data.TaskManagement.INFertilizationPlanBook;
import IDatasetFieldMap = Data.Sensor.IDatasetFieldMap;
import TaskManagementStatus = Data.TaskManagement.TaskManagementStatus;
import IDriver = Data.DocuContext.Driver.IDriver;
import IInstrument = Data.DocuContext.Instrument.IInstrument;
import IMachine = Data.DocuContext.Machine.IMachine;

@Component({
  selector: 'ap-n-fertilization-booking',
  template: `
    <ap-dyncomponent [headerIcon]="'ap-icon-n-fertilization'"
                     [columns]="columns"
                     [canCreate]="false"
                     [items]="items$ | async"
                     [pager]="pager"
                     (edit)="onEdit($event)">
    </ap-dyncomponent>
  `,
  styles: [],
  standalone: false
})
export class ApNFertilizationBookingComponent implements OnInit, AfterContentInit, OnDestroy, IEntryComponent {
  /**
   * Implements IEntryComponent
   */
  public Caption$: BehaviorSubject<string> = new BehaviorSubject('');
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  public items$ = new BehaviorSubject<INFertilizationBookingGridData[]>([]);
  public pager: ApDynGridPagerWizardConfig;
  public columns: ApDynGridColumnConfigBase[];

  private _book = true;
  private _editId: IGuid;
  private _subscriptions: Subscription[] = [];

  constructor(private campaignYearStore: CampaignYearStore,
              private cropTypeStore: CropTypeStore,
              private driverStore: DriverStore,
              private fertilizerStore: FertilizerStore,
              private fieldStore: FieldStore,
              private formStore: FormStore,
              private instrumentStore: InstrumentStore,
              private languageStore: LanguageStore,
              private machineStore: MachineStore,
              private mapViewStore: MapViewStore,
              private modalDialogStore: ModalDialogStore,
              private nFertilizationStore: NFertilizationStore,
              private timeAreaService: TimeAreaService,
              private roundNumericService: GetRoundNumericService,
              private translationService: ApTranslationService,
              private fertilizerService: FertilizerService,
              private campaignYearService: CampaignYearService,
              private dateService: ApDateService,
              private tooltipContentService: ApTooltipContentService,
              private fertilizationManagementService: FertilizationManagementService,
              private timeFormatPipe: TimeFormatPipe,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  public ngOnInit(): void {
    const data = this.formStore.Listen(s => s.updateComponent).getValue().data;
    this._book = data.book;
    this.Caption$.next(data.book ? 'Global__Booking' : 'Global__Reset');
    this.columns = this._getColumns();
    this.pager = this._getPager();
  }

  public ngAfterContentInit(): void {
    this._subscriptions.push(this.modalDialogStore.Listen(s => s.result).pipe(skip(1)).subscribe((result) => {
      if (result.key === 'apply') {
        this._updateItems({ids: [this._editId], value: result.formValues});
      }
    }));
    this._loadDataFromStore();
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  public onEdit(data: INFertilizationBookingGridData): void {
    const singleEditData = this.generateSingleEditData(data);
    const dialog = {
      title: this.translationService.translate('Admin_Pages_Popups__Book'),
      message: !this._isApplicationRateValid(data.ApplicationRate) ? 'Global__ApplicationRateZero_Dialog_Message' : null,
      show: true,
      buttons: [
        {
          key: 'cancel',
          text: 'Global__Cancel',
          primary: false
        },
        {
          key: 'apply',
          text: 'Global__Ok',
          primary: true,
          disable: ModalDialogButtonDisable.FormInvalid,
        }
      ],
      formConfig: {
        fieldSets: this.getModalDialogFieldSets(data, singleEditData, this.modalDialogStore.listenChanges()),
        validators: undefined,
        asyncValidators: undefined,
        values: ObjectFactory.Copy(singleEditData)
      }
    } as IModalDialogData;
    this._editId = data.Id;
    this.modalDialogStore.setModalDialogData(dialog);
  }

  private _booking(): void {
    if (this._book) {
      const selectedItems = this.dynComponent.getSelectedItems() as INFertilizationBookingGridData[];
      this.nFertilizationStore.BookPlanBooks(this._updateData(selectedItems));
    } else {
      this.nFertilizationStore.UnBookPlanBooks(
        this.dynComponent.getSelectedItems().map((planBookGridItem: INFertilizationBookingGridData) => {
            return {
              logfile: undefined,
              planBook: planBookGridItem.SourceItem
            };
          }
        ));
    }
    this._formClose();
  }

  private _formClose(): void {
    this.formStore.closeForm();
  }

  private cancel() {
    this._formClose();
    this.formStore.navigateToParamUrl();
  }

  private _loadDataFromStore(): void {
    this._subscriptions.push(this.formStore.Listen(s => s.updateComponent).pipe(
      map((comp) => comp.data.dataItem['PlanBooks']),
      map((planBooks: INFertilizationPlanBook[]) => {
        return planBooks.filter((planBook) => !planBook.BookedBy === this._book).map((planBook) => {
          const planBookNApplStatistics = planBook.RasterStatistics?.[1];
          const applicationRate = planBookNApplStatistics?.Mean ?? (planBook.ApplicationRate * planBook.Factor);
          const field = this.fieldStore.getFieldById(planBook.FieldId);
          const fieldGeom = this.fieldStore.getCurrentFieldGeom(field);
          const fertilizer = this.fertilizerStore.getFertilizer(planBook.ProductId);
          const fertilizerFactor = this.fertilizationManagementService.getFertilizerContent(planBook.ProductId, ApElementType.N);
          const driver = this.driverStore.getDriverById(planBook.ExportDriver);
          const machine = this.machineStore.getMachineById(planBook.ExportMachine);
          const instrument = this.instrumentStore.getInstrumentById(planBook.ExportInstrument);
          const productAmount = this.fertilizationManagementService.calculateProductAmount(
            planBook.ProductId,
            ApElementType.N,
            applicationRate,
            planBook.AreaHa ?? 0
          );
          const gridStatus = this._getGridStatus(planBook.Status);
          const average = applicationRate * (planBook.Factor ?? 0);
          const fertilizerAreaFactor = fertilizerFactor / (fieldGeom?.AreaHa ?? NeutralFactor);
          const haPerHour = this.timeAreaService.getHaPerHoursFromTotalMilliseconds(fieldGeom.AreaHa,
              planBook.Duration?.TotalMilliseconds);
          return {
            Id: planBook.Id,
            FieldId: field.Id,
            Status: planBook.Status,
            StatusClass: gridStatus.Class,
            StatusDesc: gridStatus.Desc,
            FieldName: field.FieldName,
            Nr: field.FieldNumber,
            TNr: field.FieldSubnumber,
            NrTNr: this.fieldStore.getFieldNumberAndSubNumber(field),
            Driver: driver,
            Machine: machine,
            Instrument: instrument,
            DriverId: driver?.Id,
            MachineId: machine?.Id,
            InstrumentId: instrument?.Id,
            AreaHa: fieldGeom.AreaHa,
            FertilizationDate: new Date(planBook.ApplicationDate),
            DurationInMilliseconds: planBook.Duration?.TotalMilliseconds,
            HaPerHour: haPerHour,
            CropTypeName: this.cropTypeStore.GetCropTypeName(planBook.MainCropId),
            IsExported: !!planBook.ExportedBy,
            ProductName: this.fertilizerService.getFertilizerProductName(fertilizer),
            ApplicationRate: applicationRate,
            Average: average,
            Applied: productAmount ?? 0,
            FertilizerAreaFactor: fertilizerAreaFactor,
            ApplicationRateFactor: planBook.Factor ?? NeutralFactor,
            FieldGeom: fieldGeom,
            Fertilizer: fertilizer,
            SourceItem: planBook
          } as INFertilizationBookingGridData;
        });
      })
    ).subscribe((items: INFertilizationBookingGridData[]) => {
      this.items$.next(items);
      setTimeout(() => this.dynComponent.dynGrid.gridPaging.setSelectedKeys(items.map(x => x.Id)));
    }));
  }

  // FF: Fix calculation of Application_Rate and content calculation of organic fertilizer
  private _updateData(planBookGridItems: INFertilizationBookingGridData[]): {
    planBook: INFertilizationPlanBook,
    logfile: IDatasetFieldMap
  }[] {
    return planBookGridItems.map(planBookGridItem => {
      const planBookToUpdate = ObjectFactory.Copy(planBookGridItem.SourceItem);
      if (planBookToUpdate) {
        planBookToUpdate.Start = ApTimeSpanUtil.getEmptyTimeSpan();
        planBookToUpdate.Duration = ApTimeSpanUtil.getTimeSpanFromMilliseconds(planBookGridItem.DurationInMilliseconds, true);
        planBookToUpdate.ExportDriver = planBookGridItem.Driver?.Id;
        planBookToUpdate.ExportMachine = planBookGridItem.Machine?.Id;
        planBookToUpdate.ExportInstrument = planBookGridItem.Instrument?.Id;
        planBookToUpdate.ApplicationDate = this.dateService.getDateNoon(planBookGridItem.FertilizationDate);
        planBookToUpdate.Factor = planBookGridItem.ApplicationRateFactor;
      }
      return {planBook: planBookToUpdate, logfile: undefined};
    });
  }

  private _updateItems(submitData: { ids: IGuid[], value: any }): void {
    this.items$.next(
      this.items$.getValue().map((item: INFertilizationBookingGridData) => {
        if (submitData.ids.includes(item.Id)) {
          if (!!submitData.value.FertilizationDate) {
            item.FertilizationDate = new Date(submitData.value.FertilizationDate);
          }
          if (!!submitData.value.HaPerHour) {
            const duration = this.timeAreaService.getHoursPerHaFromTotalMilliseconds(item.AreaHa,
              submitData.value.HaPerHour);
            item.HaPerHour = submitData.value.HaPerHour;
            item.DurationInMilliseconds = duration;
          }
          if (!!submitData.value.DriverId) {
            item.DriverId = submitData.value.DriverId;
            item.Driver = this.driverStore.getDriverById(submitData.value.DriverId);
          }
          if (!!submitData.value.InstrumentId) {
            item.InstrumentId = submitData.value.InstrumentId;
            item.Instrument = this.instrumentStore.getInstrumentById(submitData.value.InstrumentId);
          }
          if (!!submitData.value.MachineId) {
            item.MachineId = submitData.value.MachineId;
            item.Machine = this.machineStore.getMachineById(submitData.value.MachineId);
          }
          if (submitData.value.Average) {
            item.Applied = submitData.value.Applied;
            item.Average = this.roundNumericService.roundAsNumber(submitData.value.Average);
            item.ApplicationRateFactor = this._calculateApplicationRateFactor(item.ApplicationRate, item.Average);
          }
        }
        return item;
      })
    );
  }

  private _getColumns(): ApDynGridColumnConfigBase[] {
    return [
      new ApDynGridStatusColumnConfig({
        field: 'Status',
        class: 'StatusClass',
        description: 'StatusDesc',
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: 'Nr',
        width: 60,
        hide: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini_Subnumber',
        field: 'TNr',
        width: 60,
        hide: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Docu_Ini__Number',
        field: 'NrTNr',
        width: 70,
        hide: new ApDynGridColumnHideConfig({
          selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((mapMode) => mapMode === MapViewMode.HIDE))
        })
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'FieldName',
        title: 'Docu_Ini__Field',
        headerFilterable: true,
        width: 180,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Area',
        field: 'FieldGeom.AreaHa',
        headerFilterable: true,
        width: 60,
        format: 'n3'
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__CropType',
        field: 'CropTypeName',
        filterable: true,
        width: 100,
        headerFilterable: true,
      }),
      new ApDynGridPropertyColumnConfig({
        title: 'Global__Average_Amount',
        headerExtraLines: ['Global__KgNPerHa'],
        field: 'Average',
        width: 60,
        pipes: [{
          pipe: this.roundNumericPipe,
          args: [0]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        title: 'Global__Product',
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: 'ProductName',
            title: 'Docu_Ini__Name',
            width: 100
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Applied',
            title: 'Global__Sum_Goods',
            cssClass: 'right',
            width: 60,
            format: 'n',
            pipes: [{
              pipe: this.roundNumericPipe,
              args: [0]
            }]
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Fertilizer.Unit.Description',
            title: '',
            width: 40,
            filterable: false,
            sortable: false
          }),
        ]
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'FertilizationDate',
        title: 'Nutrients__FertilizationDate',
        hide: true,
        width: 80,
        filterable: true,
        format: this.languageStore.Listen(s => s.selectedLanguage).getValue().DateFormat,
      }),
      new ApDynGridPropertyColumnConfig({
        field: nameOf<INFertilizationBookingGridData>('DurationInMilliseconds'),
        title: `${this.translationService.translate('TotalTime')} [${this.translationService.translate('Base__UnitH')}]`,
        hide: true,
        width: 70,
        cssClass: 'right',
        headerFilterable: true,
        tooltip: (dataItem: INFertilizationBookingGridData) => this.tooltipContentService.getCapacityPerformanceTooltip(dataItem.HaPerHour),
        pipes: [{
          pipe: this.timeFormatPipe,
          args: [{
            formatType: FormatType.Decimals,
            suffixValue: 'Base__UnitH',
            decimalsFormatOptions: {
              decimalsCount: 1,
              decimalsSeparator: this.languageStore.SelectedLanguage.DecimalSeperator
            }
          }]
        }]
      }),
      new ApDynGridGroupColumnConfig({
        title: 'Settings__Lbl_Menu_Resources',
        hide: true,
        groupColumns: [
          new ApDynGridPropertyColumnConfig({
            field: 'Machine.NameWithSign',
            title: 'Base__Engine',
            width: 100,
            hide: true,
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Instrument.Name',
            title: 'AgriConnect_Ini__Tool',
            width: 100,
            hide: true
          }),
          new ApDynGridPropertyColumnConfig({
            field: 'Driver.FirstNameFullName',
            title: 'Docu_Ini__Motorist',
            width: 100,
            hide: true
          })
        ]
      }),
      new ApDynGridEditColumnConfig({})
    ];
  }

  private _getPager(): ApDynGridPagerWizardConfig {
    const nextTitle = this._book ? 'Admin_Pages_Popups__Book' : 'Global__Reset';
    return new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global_Back_With_Arrow', ApUtilService.createEventEmitter(this.cancel.bind(this), this._subscriptions)),
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardButton(nextTitle, ApUtilService.createEventEmitter(this._booking.bind(this), this._subscriptions),
        {
          primary: true,
          active: this.dynComponent.SelectedItems$.pipe(map((items) => items.length !== 0))
        }),
      {
        formConfig: {
          showMassEdit: false,
          onSubmit: ApUtilService.createEventEmitter(this._updateItems.bind(this), this._subscriptions),
          config: this.getPagerFieldSets()
        }
      }
    );
  }

  private getPagerFieldSets(): ApDynformsConfigFieldset[] {
    const selectedCampaignYear = this.campaignYearStore.getSelectedCampaignYear().Year;
    const campaignYearRange = this.campaignYearService.getCampaignYearRange(selectedCampaignYear);
    return [
      new ApDynformsConfigFieldset({
        key: 'Time',
        legend: 'Docu_Ini__Time',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigDatepicker({
            key: 'FertilizationDate',
            label: 'Nutrients__FertilizationDate',
            minDate: campaignYearRange.StartYear,
            maxDate: campaignYearRange.EndYear,
          }),
          new ApDynformsConfigPlaceholder()
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Resources',
        legend: 'Settings__Lbl_Menu_Resources',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigComboBox({
            key: 'MachineId',
            label: 'Settings__Lbl_Menu_Devices',
            valueField: nameOf<IMachine>('Id'),
            textField: nameOf<IMachine>('NameWithSign'),
            options: this.machineStore.Machines$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'InstrumentId',
            label: 'Docu_Ini__Tool',
            valueField: nameOf<IInstrument>('Id'),
            textField: nameOf<IInstrument>('Name'),
            options: this.instrumentStore.Instruments$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'DriverId',
            label: 'Docu_Ini__Motorist',
            valueField: nameOf<IDriver>('Id'),
            textField: nameOf<IDriver>('FirstNameFullName'),
            options: this.driverStore.Drivers$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigNumerictextbox({
            key: 'HaPerHour',
            label: `${this.translationService.translate('FieldAreaPerformance')} [${this.translationService.translate('Unit_ha_per_h')}]`,
            decimals: 1,
            min: 0,
            step: 0.1
          })
        ]
      })
    ];
  }

  private generateSingleEditData(gridItem: INFertilizationBookingGridData): INFertilizationBookingSingleEditData {
    const durationInTimeSpan = ApTimeSpanUtil.getTimeSpanFromMilliseconds(gridItem.DurationInMilliseconds, true);
    const average = this._calculateAverageForForm(gridItem.ApplicationRate, gridItem.FertilizerAreaFactor,
      gridItem.Applied, gridItem.Average);
    const applied = this._calculateAppliedForForm(gridItem.ApplicationRate, gridItem.FertilizerAreaFactor,
      gridItem.Applied, gridItem.Average);
    return {
      Average: average,
      Applied: applied,
      FertilizationDate: gridItem.FertilizationDate,
      MachineId: gridItem.Machine?.Id,
      DriverId: gridItem.Driver?.Id,
      InstrumentId: gridItem.Instrument?.Id,
      DurationInHours: durationInTimeSpan.TotalHours,
      HaPerHour: gridItem.HaPerHour ?? 0
    };
  }

  private getModalDialogFieldSets(gridItem: INFertilizationBookingGridData,
                                  singleEditData: INFertilizationBookingSingleEditData,
                                  formChanges$: Observable<INFertilizationBookingSingleEditData>): ApDynformsConfigFieldset[] {
    const selectedCampaignYear = this.campaignYearStore.getSelectedCampaignYear().Year;
    const campaignYearRange = this.campaignYearService.getCampaignYearRange(selectedCampaignYear);
    return [
      new ApDynformsConfigFieldset({
        key: 'Agronomy',
        legend: 'Global__Agronomy',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigNumerictextbox({
            key: nameOf<INFertilizationBookingSingleEditData>('Average'),
            label: `${this.translationService.translate('Global__Average_Amount')} ${this.translationService.translate('Global__KgNPerHa')}`,
            value$: formChanges$.pipe(
              filter(values => values && (values.Applied >= 0 || values.Average >= 0)),
              map(values => this._calculateAverageForForm(gridItem.ApplicationRate, gridItem.FertilizerAreaFactor,
                values.Applied, values.Average))
            ),
            value: singleEditData.Average,
            min: 0,
            disabled: true
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<INFertilizationBookingSingleEditData>('Applied'),
            label: this._getGoodsLabel(gridItem.Fertilizer),
            value$: formChanges$.pipe(
              filter(values => values && (values.Applied >= 0 || values.Average >= 0)),
              map(values => this._calculateAppliedForForm(gridItem.ApplicationRate, gridItem.FertilizerAreaFactor,
                values.Applied, values.Average))
            ),
            min: 0,
            value: gridItem.Applied,
            decimals: 0,
            disabled: !this._isApplicationRateValid(gridItem.ApplicationRate)
          }),
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Time',
        legend: 'Docu_Ini__Time',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigDatepicker({
            key: nameOf<INFertilizationBookingSingleEditData>('FertilizationDate'),
            label: 'Nutrients__FertilizationDate',
            value$: formChanges$.pipe(
              filter(values => !!values.FertilizationDate),
              map(values => values.FertilizationDate)
            ),
            value: singleEditData.FertilizationDate,
            minDate: campaignYearRange.StartYear,
            maxDate: campaignYearRange.EndYear
          })
        ]
      }),
      new ApDynformsConfigFieldset({
        key: 'Resources',
        legend: 'Settings__Lbl_Menu_Resources',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigComboBox({
            key: nameOf<INFertilizationBookingSingleEditData>('MachineId'),
            label: 'Settings__Lbl_Menu_Devices',
            valueField: nameOf<IMachine>('Id'),
            textField: nameOf<IMachine>('NameWithSign'),
            value: singleEditData.MachineId,
            value$: formChanges$.pipe(
              filter(values => !!values.MachineId),
              map(values => values.MachineId)
            ),
            options: this.machineStore.Machines$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: nameOf<INFertilizationBookingSingleEditData>('InstrumentId'),
            label: 'Docu_Ini__Tool',
            valueField: nameOf<IInstrument>('Id'),
            textField: nameOf<IInstrument>('Name'),
            value: singleEditData.InstrumentId,
            value$: formChanges$.pipe(
              filter(values => !!values.MachineId || !!values.InstrumentId),
              map(values => {
                if (!!values.InstrumentId) {
                  return values.InstrumentId;
                }
                const formValues = this.modalDialogStore.getFormValues() as INFertilizationBookingSingleEditData;
                if (!!formValues.InstrumentId) {
                  return formValues.InstrumentId;
                }
                const machine = this.machineStore.getMachineById(values.MachineId);
                if (!!machine?.DefaultInstrument?.Id) {
                  return machine.DefaultInstrument.Id;
                }
                return undefined;
              })
            ),
            options: this.instrumentStore.Instruments$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: nameOf<INFertilizationBookingSingleEditData>('DriverId'),
            label: 'Docu_Ini__Motorist',
            valueField: nameOf<IDriver>('Id'),
            textField: nameOf<IDriver>('FirstNameFullName'),
            value: singleEditData.DriverId,
            value$: formChanges$.pipe(
              filter(values => !!values.MachineId || !!values.DriverId),
              map(values => {
                if (!!values.DriverId) {
                  return values.DriverId;
                }
                const formValues = this.modalDialogStore.getFormValues() as INFertilizationBookingSingleEditData;
                if (formValues.DriverId) {
                  return formValues.DriverId;
                }
                const machine = this.machineStore.getMachineById(values.MachineId);
                if (!!machine?.DefaultDriver?.Id) {
                  return machine.DefaultDriver.Id;
                }
                return null;
              })
            ),
            options: this.driverStore.Drivers$,
            valuePrimitive: true,
            sort: 1
          }),
          new ApDynformsConfigPlaceholder(),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<INFertilizationBookingSingleEditData>('DurationInHours'),
            label: `${this.translationService.translate('Docu_Ini__Duration')} [${this.translationService.translate('Base__UnitH')}]`,
            value: singleEditData.DurationInHours,
            decimals: 1,
            min: 0,
            step: 0.1
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<INFertilizationBookingSingleEditData>('HaPerHour'),
            label: `${this.translationService.translate('FieldAreaPerformance')} [${this.translationService.translate('Unit_ha_per_h')}]`,
            value: singleEditData.HaPerHour,
            value$: formChanges$.pipe(
              filter(x => Number.isFinite(gridItem.AreaHa) && Number.isFinite(x.DurationInHours)),
              map(c => {
                const result = gridItem.AreaHa / c.DurationInHours;
                return Number.isFinite(result) ? result : 0;
              })
            ),
            decimals: 1,
            min: 0,
            step: 0.1,
            disabled: true
          })
        ]
      }),
    ];
  }

  /**
   * Determines whether the given application rate is valid.
   * @param applicationRate - The application rate to validate.
   * @return Returns true if the application rate is finite and greater than zero, otherwise false.
   * @private
   */
  private _isApplicationRateValid(applicationRate: number | null): boolean {
    return Number.isFinite(applicationRate) && applicationRate > 0;
  }

  /**
   * Calculates the average value for a form based on the application rate, fertilizer area factor, applied value, and default average.
   * @param applicationRate - The application rate used to determine if a valid calculation can be made.
   * @param fertilizerAreaFactor - A factor that is applied to scale the applied value.
   * @param applied - The applied value used in the calculation when the application rate is valid.
   * @param average - The default average value to return when the application rate is not valid.
   * @return The calculated average value based on the inputs and application rate validity.
   * @private
   */
  private _calculateAverageForForm(applicationRate: number, fertilizerAreaFactor: number, applied: number,
                                   average: number): number {
    return this._isApplicationRateValid(applicationRate) ? applied * fertilizerAreaFactor : average;
  }

  /**
   * Calculates the applied amount for a form based on the application rate,
   * fertilizer area factor, applied amount, and average value.
   * @param applicationRate - The rate of application to be checked for validity.
   * @param fertilizerAreaFactor - Factor determining the area to which fertilizer is applied.
   * @param applied - The already applied amount.
   * @param average - The average value to be used if the application rate is invalid.
   * @return The calculated applied amount for the form.
   * @private
   */
  private _calculateAppliedForForm(applicationRate: number, fertilizerAreaFactor: number, applied: number,
                                   average: number): number {
    return this._isApplicationRateValid(applicationRate) ? applied : average / fertilizerAreaFactor;
  }

  /**
   * Calculates the application rate factor based on the provided application rate and average.
   * @param applicationRate - The input application rate to validate and use in the calculation.
   * @param average - The average value used to compute the rate factor.
   * @return The application rate factor. If the application rate is invalid, returns 1.
   * @private
   */
  private _calculateApplicationRateFactor(applicationRate: number, average: number): number {
    return this._isApplicationRateValid(applicationRate) ? average / applicationRate : 1;
  }

  private _getGridStatus(status: TaskManagementStatus): { Class: string, Desc: string } {
    switch (status) {
      case TaskManagementStatus.Green:
        return {Class: 'ap-status-green', Desc: ''};
      case TaskManagementStatus.Yellow:
        return {Class: 'ap-status-yellow', Desc: ''};
      case TaskManagementStatus.Red:
        return {Class: 'ap-status-red', Desc: ''};
    }
  }

  private _getGoodsLabel(fertilizer: CombinedFertilizer): string {
    switch (fertilizer?.Unit?.Description) {
      case 'm³':
        return 'Global__GoodsSpread_m3';
      case 'l':
        return 'Global__GoodsSpread_l';
      case 't':
        return 'Global__GoodsSpread_t';
      default:
        return 'Global__GoodsSpread_kg';
    }
  }
}
